import React, {
    ReactElement,
    useEffect,
    useState,
    useCallback,
} from 'react';
import {SchemaWithClient} from '../../types/SchemaWithClient';
import {Entity} from '../../types/entities/Entity';
import {
  Button, Switch,
  Table,
  TableContainer,
} from '@mui/material';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import api from '../../services/api';
import TableBody from '@mui/material/TableBody';
import DialogContent from "@mui/material/DialogContent";

type Props<T extends Entity> = {
    schema: SchemaWithClient<T>;
};

export const UpdateAddressDialog = ({
                            params,
                            onClose,
                        }: {
    params: any;
    onClose: () => void;
}): ReactElement => {

    const [rows, setRows] = useState([]);

    const fetchData = useCallback(() => {
        api.get(`/activity-reservations/${params?.id}/service-reservations`).then((res: any) => {
            setRows(res);
        });
    }, []);

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <>
            <Dialog
              open={true}
              onClose={() => {
                  onClose();
              }}
            >
                <DialogTitle>
                    {'Service Reservation updates'}
                </DialogTitle>
                <DialogContent>

                    <TableContainer>
                        <Table size="small">
                            <TableHead
                              sx={{
                                  '& .MuiTableCell-root': {
                                      color: 'inherit',
                                      border: 'none',
                                  },
                                  '& .MuiTableRow-root .MuiTableCell-root.MuiTableCell-head': {
                                      border: 'none',
                                      fontSize: '14px',
                                      p: '10px 15px',
                                  },
                                  '& .MuiTableRow-root .MuiTableCell-root .MuiFormControl-root.MuiTextField-root': {
                                      background: '#f9f9f9',
                                      boxShadow: 'inset 0px 0px 1px #a7a7a7',
                                  },
                                  background: '#256861',
                                  color: '#fff',
                              }}
                            >
                                <TableRow>
                                    <TableCell>#</TableCell>
                                    <TableCell>Date</TableCell>
                                    <TableCell>Start Time</TableCell>
                                    <TableCell>Service Group</TableCell>
                                    <TableCell>Service Provider</TableCell>
                                    <TableCell>Service</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>

                                {rows.map((reservation:any)=>{
                                    return (
                                      <TableRow>
                                          <TableCell>
                                            <Switch
                                              checked={reservation?.update_address}
                                              onChange={(event, checked) => {

                                                const res:any = rows.map((item:any)=>{

                                                  if (reservation.id===item?.id){
                                                    const tempItem = {...item};
                                                    tempItem.update_address = checked;
                                                    return tempItem
                                                  }

                                                  return item;
                                                });

                                                setRows(res);

                                              }}
                                            />
                                          </TableCell>
                                          <TableCell>{reservation?.date}</TableCell>
                                          <TableCell>{reservation?.time}</TableCell>
                                          <TableCell>{reservation?.service_group?.name}</TableCell>
                                          <TableCell>{reservation?.service_provider?.name}</TableCell>
                                          <TableCell>{reservation?.service?.name}</TableCell>
                                      </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>


                </DialogContent>
                <DialogActions>
                    <Button
                      onClick={() => {
                        onClose();
                      }}
                    >
                        Cancel
                    </Button>

                </DialogActions>
            </Dialog>
        </>
    );
};
